import React, { createContext, useContext, useState, useEffect } from 'react';
import { createAbility } from '../services/abilityService';
import { authService } from '../services/authService';

export const AbilityContext = createContext();

export const useAbility = () => {
  const context = useContext(AbilityContext);
  if (!context) {
    throw new Error('useAbility must be used within an AbilityProvider');
  }
  return context.ability;
};

export const AbilityProvider = ({ children }) => {
  const [ability, setAbility] = useState(createAbility('Administrador'));
  const [userRole, setUserRole] = useState('Administrador');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const initializeAbility = async () => {
      try {
        const role = await authService.getUserRole();
        setUserRole(role);
        setAbility(createAbility(role));
      } catch (error) {
        console.error('Error initializing ability:', error);
        setAbility(createAbility('Administrador'));
      } finally {
        setLoading(false);
      }
    };

    initializeAbility();

    // Subscribe to auth state changes to update ability when user logs in/out
    const { unsubscribe } = authService.onAuthStateChange(async (event, session) => {
      if (event === 'SIGNED_IN' || event === 'TOKEN_REFRESHED') {
        const role = await authService.getUserRole();
        setUserRole(role);
        setAbility(createAbility(role));
      } else if (event === 'SIGNED_OUT') {
        setUserRole('Administrador');
        setAbility(createAbility('Administrador'));
      }
    });

    return () => {
      unsubscribe();
    };
  }, []);

  const updateAbility = (role) => {
    setUserRole(role);
    setAbility(createAbility(role));
  };

  return (
    <AbilityContext.Provider value={{ ability, userRole, updateAbility, loading }}>
      {children}
    </AbilityContext.Provider>
  );
};
